var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5234 1.67676L15.6172 0.739258C15.0312 0.62207 14.4453 0.895508 14.2109 1.44238L12.375 5.7002C12.1797 6.20801 12.2969 6.79395 12.7266 7.10645L14.8359 8.8252C13.5078 11.5596 11.3203 13.7471 8.58594 15.0752L6.86719 12.9658C6.55469 12.5361 5.96875 12.4189 5.46094 12.6143L1.20312 14.4502C0.695312 14.6846 0.382812 15.2705 0.5 15.8174L1.4375 19.7627C1.55469 20.3096 2.02344 20.7002 2.60938 20.7002C12.4531 20.7002 20.5 12.7314 20.5 2.84863C20.5 2.2627 20.1094 1.79395 19.5234 1.67676ZM2.64844 19.4502L1.75 15.583L5.92969 13.7861L8.27344 16.6377C12.2969 14.7236 14.4844 12.5361 16.3984 8.5127L13.5469 6.16895L15.3438 1.98926L19.2109 2.8877C19.2109 12.0283 11.7891 19.4502 2.64844 19.4502Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dc5e63a5.svg";
export { ForwardRef as ReactComponent };